import React from 'react';
import './My_pms.css';

import GGApi from '../../../utils/GGApi.js';
import config from '../../../utils/config.js';
import { loadStripe } from '@stripe/stripe-js';

import GG_loader from '../../general_components/GG_loader/GG_loader.js';
import Overlay_popup from '../../general_components/Overlay_popup/Overlay_popup';
import { Helmet } from 'react-helmet';
import List_w_Category from '../../general_components/List_w_Category/List_w_Category.js';


// settings page: handles the user's payment methods

class My_pms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            pm_list: [],

            open_overlay: false,
            pm_to_verify: {},
            descriptor_code: ''
        }

        this.toggle_loading = this.toggle_loading.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.handleOverlayButton = this.handleOverlayButton.bind(this);
        this.handleVerifyClick = this.handleVerifyClick.bind(this);


    }

    componentDidMount() {        
        // load pm list
        GGApi.pm_get().then(list => {
            this.setState({
                loading: false,
                pm_list: list
            })
        });
    }
    
    // toggles

    toggle_loading(){
        this.setState({loading: !this.state.loading})
    }

    handleChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value});
    }
    // button handlers

    // remove outdated connections and notify the user
    handleVerifyClick(item){
        if(item && item.integration && item.integration !== 'us_bank_account'){
            this.setState({loading: true});
            GGApi.remove_outdated_bank(item.id).then(response => {
                GGApi.pm_get().then(list => {
                    this.setState({loading: false, pm_list: list});
                    alert((response && response.message) || 'We\'re removing this bank account because it uses an outdated verification method. Please add your bank again to continue.');
                });
            });
            return;
        }
        this.setState({pm_to_verify: item, open_overlay: true});
    }

    handleOverlayButton(){
        if(!this.state.pm_to_verify){
            return
        };
        if(!this.state.descriptor_code || !this.state.descriptor_code.trim()){
            alert('Please enter the verification code from your bank statement.')
            return;
        }
        this.setState({loading: true});

        const bankId = this.state.pm_to_verify.id;
        const descriptorCode = this.state.descriptor_code.trim();

        // --- Client-side microdeposit verify when SetupIntent is in requires_action ---
        GGApi.bank_verify_prepare(bankId)
        .then(async (prep) => {
            if (prep.already_verified) {
                return GGApi.verify_manual_bank(descriptorCode, bankId);
            }
            if (prep.success && prep.client_secret) {
                const stripe = await loadStripe(config.stripe.public_key);
                if (!stripe) {
                    throw new Error('Payment system failed to load.');
                }
                const clientResult = await stripe.verifyMicrodepositsForSetup(
                    prep.client_secret,
                    { descriptor_code: descriptorCode.toUpperCase() }
                );
                if (clientResult.error) {
                    throw new Error(clientResult.error.message || 'Verification failed.');
                }
            } else if (!prep.success) {
                throw new Error(prep.message || 'Could not prepare bank verification.');
            }
            return GGApi.verify_manual_bank(descriptorCode, bankId);
        })
        .then(response => {
            console.log(response);
            if(response.success){
                GGApi.pm_get().then(list => {
                    this.setState({
                        loading: false,
                        pm_list: list,
                        open_overlay: false,
                        pm_to_verify: {},
                        descriptor_code: ''
                    })
                    alert('Successfully verified your bank account.')
                });
            } else {
                this.setState({
                    loading: false
                })
                alert('An error has occurred. Please try again.')
            }
        })
        .catch((err) => {

            // log the error to the BE server
            GGApi.admin_log_event('My_pms verify error: ' + err.message);

            this.setState({ loading: false });
            alert('Verification failed. Please try again or contact Greatest Gift support.');
        });
    }

    // render methods



    render () {
        if(this.state.loading) {
            return (
                <GG_loader />
            )
        }

        return (
        <main>
                <Helmet>
                    <title>{`Payment Methods | Greatest Gift`}</title>
                    <meta name="description"
                        content='See and manage your payment methods.' 
                    />
                </Helmet>
            <h2>My Payment Methods</h2>
            <ul className='pm_category_list'>
                <List_w_Category
                    list={this.state.pm_list}
                    onVerifyClick={(item) => this.handleVerifyClick(item)}
                    button_text={'Verify'}
                />
            </ul>

            
            <Overlay_popup 
                open={this.state.open_overlay}
                closer={true}
                handleClose={() => this.setState({open_overlay: false, descriptor_code: '', pm_to_verify: {}})}
                overlay_title='Verify Account'
                body_2='Deposits may take 1-3 business days to appear in your account.'
                body_1='Please enter the 6-character verification code from the small deposit on your statement. '
                form={<form>

                    <p className='form_label'>Verification code:</p>
                    <input
                                type='text'
                                id='descriptor_code'
                                onChange={this.handleChange}
                                name='descriptor_code'
                                placeholder='SM1234'
                                value={this.state.descriptor_code}
                                autoFocus
                                maxLength='12'
                                autoComplete='off'
                                />
                </form>}
                button_1={{text: 'Verify', handler: this.handleOverlayButton}}
            />

            <div className='buffer'></div>
    
        </main> 
        );
    }
}

export default My_pms;